import { UserDialogView } from 'src/app/landing-page/landing-page.modal';

export interface LandingPage {
  activeSignButton: UserDialogView;
  signInDetails: SignInDetails;
  signUpDetails: SignUpDetails;
  fpDetails: FPDetails;
  signInResponse: SignInResponse;
  signUpResponse: SignUpResponse;
  isPasswordUpdated: boolean;
  isOTPRequested: boolean;
  isOTPSent: boolean;
}

export interface SignUpResponse {
  status: number;
  message: string;
  error: string;
}

export interface PyResponse {
  status: number;
  message: string;
  error: string;
}

export interface FPDetails {
  emailId: string;
  newPassword: string;
  otp: string;
}

export interface SignInDetails {
  email: string;
  password: string;
  rememberMe: boolean;
}

export interface SignUpDetails {
  firstName: string;
  lastName: string;
  emailId: string;
  phoneNumber: string;
  password: string;
  confirmPassword?: string;
  country: string;
  country_code: string;
  state: string;
  zip: string;
  isAgreementAndPrivacyAgreed: boolean;
  zip_ext?: string;
  addressLine1?: string;
  addressLine2?: string;
}

export interface SignInPayload {
  userId: string;
  password: string;
}

export interface SignInResponse {
  userId: string;
}

export const initialState: LandingPage = {
  activeSignButton: UserDialogView.CLOSE,
  signInDetails: null,
  signUpDetails: null,
  fpDetails: null,
  signInResponse: null,
  signUpResponse: null,
  isPasswordUpdated: false,
  isOTPRequested: false,
  isOTPSent: false,
};

export interface LandingHttpResponse {
  status: number;
  message: string;
  error: string;
}

export interface LandingPageState {
  landingPageState: LandingPage;
}
